import React from 'react';

import type { PollComponent } from '../../../../../../core/data-sources/content-components/types.js';

import { Form } from './components/Form.js';

const Poll: React.FC<PollComponent> = ({
  question,
  options,
  image,
  id,
  statistics,
  expirationDate,
}: PollComponent) => {
  return (
    <section className="poll" data-pulse-entity-id={`poll-${id}`}>
      <Form
        initialStatistics={statistics}
        question={question}
        options={options}
        imageAsset={image?.imageAsset}
        id={id}
        requiresLogin={true}
        expirationDate={expirationDate}
      />
    </section>
  );
};
export default Poll;
